import { useState } from "react";

/**
 * Someone's face.
 *
 * The photo comes from authentik, cached and served by us so no device in the
 * house fetches from a third party. If it is missing — not synced yet, or no
 * authentik account — the emoji is not a placeholder but a perfectly good
 * answer, and for the youngest reader it is the better one.
 */
export function Face({
  person,
  size = "md",
}: {
  person: { personId?: number; id?: number; name: string; emoji: string; hasAvatar?: boolean };
  size?: "sm" | "md" | "lg";
}) {
  const id = person.personId ?? person.id;
  const [failed, setFailed] = useState(false);
  const showPhoto = person.hasAvatar !== false && id !== undefined && !failed;

  return (
    <span className={`face face--${size}`} aria-hidden="true">
      {showPhoto ? (
        <img className="face__img" src={`/api/people/${id}/avatar`} alt="" onError={() => setFailed(true)} />
      ) : (
        person.emoji
      )}
    </span>
  );
}
